import {
    ActionType, ERPDimensionSyncType, IntegrationSource, IntegrationSourceStatus, NetvisorSyncDefaultHandleType,
    NetworkActionPrefix, RawDataMappingColumnDataType, RawDataSourceStatus, RequestStatus
} from '../utils/constants';
import { deepAssign } from '../utils';
import defaults from '../api/defaults';
import {
    combineReducers, networkActionReducer, networkEntityAddAllReducer, networkEntityAddReducer, networkEntityDeleteAllReducer, networkEntityDeleteReducer, networkEntityEditAllReducer,
    networkEntityEditReducer, networkEntityLoadReducer, networkObjectLoadReducer, networkObjectVoidReducer, networkPaginationLoadReducer, pipeReducers, synchronizableEnumReducer
} from '../utils/reducerFactory';

function index(state, id) {
    return id !== undefined ? (id = state.getIndexByID(id)) !== -1 ? id : state.length : undefined;
}

const keyVariables = {
        integrationSourceCompanyStatusIndex: (state, action) => index(state, action.integrationSourceCompanyStatusID),
        erpNetvisorIntegrationSettingsIndex: (state, action) => index(state, action.eRPNetvisorIntegrationSettingsID),
        erpFivaldiIntegrationSettingsIndex: (state, action) => index(state, action.eRPFivaldiIntegrationSettingsID),
        erpProcountorIntegrationSettingsIndex: (state, action) => index(state, action.eRPProcountorIntegrationSettingsID),
        integrationPipedriveSettingsIndex: (state, action) => index(state, action.integrationPipedriveSettingsID),
        integrationPipedriveSettingsPipelineIndex: (state, action) => index(state, action.integrationPipedriveSettingsPipelineID),
        integrationPipedriveSettingsPipelineStageIndex: (state, action) => index(state, action.integrationPipedriveSettingsPipelineStageID),
        rawDataMappingColumnIndex: (state, action) => index(state, action.rawDataMappingColumnID),
        rawDataMappingIndex: (state, action) => index(state, action.rawDataMappingID),
        rawDataSourceIndex: (state, action) => index(state, action.rawDataSourceID),
        severaIntegrationSettingsIndex: (state, action) => index(state, action.severaIntegrationSettingsID)
    },

    integrations = pipeReducers(
        combineReducers({
            googleAnalyticsAccounts: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.GET_GOOGLE_ANALYTICS_ACCOUNT_INFORMATION_PREFIX, defaults.NetworkArray),
                (state, action) => {
                    if (action.type === ActionType.EDIT_GOOGLE_ANALYTICS_SETTINGS_SUCCESS && !action.googleAnalyticsSettings.GoogleOAuthUserID) {
                        return defaults.NetworkArray;
                    }

                    return state;
                }
            ),
            googleAnalyticsSettings: pipeReducers(
                networkActionReducer(NetworkActionPrefix.LOAD_GOOGLE_ANALYTICS_SETTINGS_PREFIX, defaults.GoogleAnalyticsSettings),
                networkEntityAddReducer(NetworkActionPrefix.ADD_GOOGLE_ANALYTICS_SETTINGS_PREFIX, null, (state, action) => action.googleAnalyticsSettings),
                networkEntityEditReducer(NetworkActionPrefix.EDIT_GOOGLE_ANALYTICS_SETTINGS_PREFIX, null, (state, action) => action.googleAnalyticsSettings),
                combineReducers({
                    Custom: combineReducers({
                        isAuthenticated: networkObjectLoadReducer(NetworkActionPrefix.CHECK_GOOGLE_ANALYTICS_AUTHENTICATION_PREFIX, defaults.GoogleAnalyticsSettings.Custom.isAuthenticated)
                    })
                }),
                (state, action) => {
                    switch (action.type) {
                        case ActionType.DELETE_GOOGLE_OAUTH_USER_SUCCESS:
                            if (action.googleOAuthUserID === state.GoogleOAuthUserID) {
                                return deepAssign(state, { GoogleOAuthUserID: null });
                            }

                            return state;

                        case ActionType.LOAD_GOOGLE_ANALYTICS_SETTINGS_SUCCESS:
                            if (action.response) {
                                return deepAssign(state, {
                                    Custom: state.Custom,
                                    ...action.response
                                });
                            }

                            return state;

                        default:
                            return state;
                    }
                }
            ),
            erpNetvisorIntegrationSettings: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_ERP_NETVISOR_INTEGRATION_SETTINGSES_PREFIX, defaults.NetworkArray),
                combineReducers({
                    Data: combineReducers({
                        '@erpNetvisorIntegrationSettingsIndex': pipeReducers(
                            networkEntityAddReducer(NetworkActionPrefix.ADD_ERP_NETVISOR_INTEGRATION_SETTINGS_PREFIX, null, (state, action) => action.eRPNetvisorIntegrationSettings),
                            networkEntityEditReducer(NetworkActionPrefix.EDIT_ERP_NETVISOR_INTEGRATION_SETTINGS_PREFIX, defaults.ERPNetvisorIntegrationSettings, (state, action) => action.eRPNetvisorIntegrationSettings),
                            networkEntityDeleteReducer(NetworkActionPrefix.DELETE_ERP_NETVISOR_INTEGRATION_SETTINGS_PREFIX)
                        )
                    }, keyVariables)
                }),
                networkObjectVoidReducer(ActionType.VOID_ALL_INTEGRATION_SOURCE_COMPANY_STATUSES)
            ),
            erpFinancialIntegrationTestResult: pipeReducers(
                (state, action) => {
                    switch (action.type) {
                        case ActionType.CHECK_FIVALDI_CONNECTION:
                        case ActionType.TEST_NETVISOR_INTEGRATION_SETTINGS:
                            return deepAssign(state, {
                                Data: false
                            });

                        case ActionType.CHECK_FIVALDI_CONNECTION_SUCCESS:
                        case ActionType.TEST_NETVISOR_INTEGRATION_SETTINGS_SUCCESS:
                            return deepAssign(state, {
                                Data: action.response
                            });

                        case ActionType.ADD_ERP_FIVALDI_INTEGRATION_SETTINGS_SUCCESS:
                        case ActionType.ADD_ERP_NETVISOR_INTEGRATION_SETTINGS_SUCCESS:
                        case ActionType.DROP_ERP_FINANCIAL_INTEGRATION_TEST_RESULT:
                            return deepAssign(defaults.NetworkObject, { Data: false });

                        default:
                            return state || deepAssign(defaults.NetworkObject, { Data: false });
                    }
                },
                networkActionReducer(NetworkActionPrefix.CHECK_FIVALDI_CONNECTION_PREFIX),
                networkActionReducer(NetworkActionPrefix.TEST_NETVISOR_INTEGRATION_SETTINGS_PREFIX)
            ),
            integrationSources: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_INTEGRATION_SOURCES_PREFIX, defaults.NetworkArray, IntegrationSource, 'IntegrationSource'),
            netvisorSyncDefaultHandleTypes: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_INTEGRATION_SETTINGS_NETVISOR_SYNC_DEFAULT_HANDLE_TYPES_PREFIX, defaults.NetworkArray, NetvisorSyncDefaultHandleType, 'IntegrationSettingsNetvisorSyncDefaultHandleType'),
            integrationSourceCompanyStatuses: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_INTEGRATION_SOURCE_COMPANY_STATUSES_PREFIX, defaults.NetworkArray),
                combineReducers({
                    Data: combineReducers({
                        '@integrationSourceCompanyStatusIndex': pipeReducers(
                            networkActionReducer(NetworkActionPrefix.SET_INTEGRATION_SOURCE_ACTIVE_AND_GET_NEW_STATUS_PREFIX),
                            networkEntityAddReducer(NetworkActionPrefix.ADD_INTEGRATION_SOURCE_COMPANY_STATUS_PREFIX, null, (state, action) => action.integrationSourceCompanyStatus),
                            (state, action) => {
                                switch (action.type) {
                                    case ActionType.SET_INTEGRATION_SOURCE_ACTIVE_AND_GET_NEW_STATUS_SUCCESS:
                                        return deepAssign(state, { IsActive: true, SourceStatusID: action.response });

                                    default:
                                        return state;
                                }
                            }
                        )
                    }, keyVariables)
                }),
                (state, action) => {
                    switch (action.type) {
                        case ActionType.UPDATE_NETVISOR_DATA_PENDING:
                        case ActionType.UPDATE_FIVALDI_DATA_PENDING:
                        case ActionType.UPDATE_PROCOUNTOR_DATA_PENDING:
                        case ActionType.UPDATE_SEVERA_DATA_PENDING:
                            return deepAssign(state, {
                                Data: {
                                    [state.Data.findIndex(sourceStatus => sourceStatus.SourceID === action.integrationSourceID)]: {
                                        SourceStatusID: IntegrationSourceStatus.IN_PROGRESS,
                                        Custom: { status: RequestStatus.PENDING }
                                    }
                                }
                            });

                        case ActionType.UPDATE_NETVISOR_DATA_FAIL:
                        case ActionType.UPDATE_FIVALDI_DATA_FAIL:
                        case ActionType.UPDATE_PROCOUNTOR_DATA_FAIL:
                        case ActionType.UPDATE_SEVERA_DATA_FAIL:
                            return deepAssign(state, {
                                Data: {
                                    [state.Data.findIndex(sourceStatus => sourceStatus.SourceID === action.integrationSourceID)]: {
                                        Custom: { status: RequestStatus.FAILED }
                                    }
                                }
                            });


                        case ActionType.UPDATE_NETVISOR_DATA_SUCCESS:
                        case ActionType.UPDATE_FIVALDI_DATA_SUCCESS:
                        case ActionType.UPDATE_PROCOUNTOR_DATA_SUCCESS:
                        case ActionType.UPDATE_SEVERA_DATA_SUCCESS:
                            return deepAssign(state, {
                                Data: {
                                    [state.Data.findIndex(sourceStatus => sourceStatus.SourceID === action.integrationSourceID)]: {
                                        SourceStatusID: IntegrationSourceStatus.IN_PROGRESS,
                                        Custom: { status: RequestStatus.SUCCEEDED }
                                    }
                                }
                            });

                        case ActionType.ADD_ERP_NETVISOR_INTEGRATION_SETTINGS_SUCCESS:
                            return deepAssign(state, {
                                Data: {
                                    [state.Data.findIndex(sourceStatus => sourceStatus.SourceID === IntegrationSource.NETVISOR)]: {
                                        SourceStatusID: IntegrationSourceStatus.IN_PROGRESS
                                    }
                                }
                            });

                        case ActionType.UPDATE_PIPEDRIVE_DATA_SUCCESS:
                            return deepAssign(state, {
                                Data: {
                                    [state.Data.findIndex(sourceStatus => sourceStatus.SourceID === IntegrationSource.PIPEDRIVE)]: {
                                        SourceStatusID: IntegrationSourceStatus.IN_PROGRESS
                                    }
                                }
                            });

                        case ActionType.VOID_ALL_DASHBOARD_PAGES:
                            return defaults.NetworkArray;

                        case ActionType.DEMAND_DATA_FROM_INTEGRATION_SOURCE_PENDING:
                        case ActionType.DEMAND_DATA_FROM_INTEGRATION_SOURCE_SUCCESS:
                        case ActionType.DEMAND_DATA_FROM_INTEGRATION_SOURCE_FAIL:
                        case ActionType.DEMAND_SPECIFIC_DATA_FROM_INTEGRATION_SOURCE_PENDING:
                        case ActionType.DEMAND_SPECIFIC_DATA_FROM_INTEGRATION_SOURCE_SUCCESS:
                        case ActionType.DEMAND_SPECIFIC_DATA_FROM_INTEGRATION_SOURCE_FAIL:
                            const
                                baseActionType = action.type.substring(0, action.type.lastIndexOf('_')),
                                statusIndex = state.Data.findIndex(sourceStatus => sourceStatus.SourceID === action.integrationSourceID);

                            if (statusIndex >= 0) {
                                const status = state.Data[statusIndex];

                                return deepAssign(state, {
                                    Data: {
                                        [statusIndex]: {
                                            ...networkActionReducer(baseActionType)(status, action),
                                            SourceStatusID: IntegrationSourceStatus.IN_PROGRESS
                                        }
                                    }
                                });
                            }

                            return state;

                        case ActionType.IMPORT_INTEGRATION_FINANCIAL_UPLOAD_EXCEL_BATCH_SUCCESS:
                            if (action.startBackgroundWorker) {
                                return deepAssign(state, {
                                    Data: {
                                        [state.Data.findIndex(sourceStatus => sourceStatus.SourceID === IntegrationSource.EXCEL)]: {
                                            SourceStatusID: IntegrationSourceStatus.IN_PROGRESS
                                        }
                                    }
                                });
                            }

                            return state;

                        case ActionType.IMPORT_AND_PROCESS_INTEGRATION_FINANCIAL_FILES_SUCCESS:
                            if (action.sourceID !== IntegrationSource.L7 || action.startImmediately) {
                                return deepAssign(state, {
                                    Data: {
                                        [state.Data.findIndex(({ SourceID }) => SourceID === action.sourceID)]: {
                                            SourceStatusID: IntegrationSourceStatus.IN_PROGRESS
                                        }
                                    }
                                });
                            }

                            return state;

                        case ActionType.IMPORT_NETVISOR_BUDGET_SUCCESS:
                            return deepAssign(state, {
                                Data: {
                                    [state.Data.findIndex(({ SourceID }) => SourceID === IntegrationSource.NETVISOR)]: {
                                        SourceStatusID: IntegrationSourceStatus.IN_PROGRESS
                                    }
                                }
                            });

                        default:
                            return state;
                    }
                },
                networkObjectVoidReducer(ActionType.VOID_ALL_INTEGRATION_SOURCE_COMPANY_STATUSES)
            ),
            erpDimensionSyncTypes: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_ERP_DIMENSION_SYNC_TYPES_PREFIX, defaults.NetworkArray, ERPDimensionSyncType, 'ERPDimensionSyncType'),
            erpFinancialAdvisorySettings: pipeReducers(
                networkEntityLoadReducer(NetworkActionPrefix.LOAD_ERP_FINANCIAL_ADVISORY_SETTINGS_PREFIX, defaults.NetworkObjectOf(defaults.ERPFinancialAdvisorySettings)),
                networkEntityEditReducer(NetworkActionPrefix.EDIT_ERP_FINANCIAL_ADVISORY_SETTINGS_PREFIX, null, (state, action) => action.eRPFinancialAdvisorySettings)
            ),
            erpFivaldiIntegrationSettings: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_ERP_FIVALDI_INTEGRATION_SETTINGSES_PREFIX, defaults.NetworkArray),
                combineReducers({
                    Data: combineReducers({
                        '@erpFivaldiIntegrationSettingsIndex': pipeReducers(
                            networkEntityAddReducer(NetworkActionPrefix.ADD_ERP_FIVALDI_INTEGRATION_SETTINGS_PREFIX, null, (state, action) => action.eRPFivaldiIntegrationSettings),
                            networkEntityEditReducer(NetworkActionPrefix.EDIT_ERP_FIVALDI_INTEGRATION_SETTINGS_PREFIX, defaults.ERPFivaldiIntegrationSettings, (state, action) => action.eRPFivaldiIntegrationSettings),
                            networkEntityDeleteReducer(NetworkActionPrefix.DELETE_ERP_FIVALDI_INTEGRATION_SETTINGS_PREFIX)
                        )
                    }, keyVariables)
                }),
                networkObjectVoidReducer(ActionType.VOID_ALL_INTEGRATION_SOURCE_COMPANY_STATUSES)
            ),
            erpProcountorIntegrationSettings: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_ERP_PROCOUNTOR_INTEGRATION_SETTINGSES_PREFIX, defaults.NetworkArray),
                combineReducers({
                    Data: combineReducers({
                        '@erpProcountorIntegrationSettingsIndex': pipeReducers(
                            networkEntityAddReducer(NetworkActionPrefix.ADD_ERP_PROCOUNTOR_INTEGRATION_SETTINGS_PREFIX, null, (state, action) => action.eRPProcountorIntegrationSettings),
                            networkEntityEditReducer(NetworkActionPrefix.EDIT_ERP_PROCOUNTOR_INTEGRATION_SETTINGS_PREFIX, defaults.ERPProcountorIntegrationSettings, (state, action) => action.eRPProcountorIntegrationSettings),
                            networkEntityDeleteReducer(NetworkActionPrefix.DELETE_ERP_PROCOUNTOR_INTEGRATION_SETTINGS_PREFIX)
                        )
                    }, keyVariables)
                }),
                networkObjectVoidReducer(ActionType.VOID_ALL_INTEGRATION_SOURCE_COMPANY_STATUSES)
            ),
            integrationPipedriveSettings: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_INTEGRATION_PIPEDRIVE_SETTINGSES_PREFIX, defaults.NetworkArray),
                combineReducers({
                    Data: combineReducers({
                        '@integrationPipedriveSettingsIndex': pipeReducers(
                            networkEntityLoadReducer(NetworkActionPrefix.SYNC_PIPEDRIVE_PIPELINES_PREFIX),
                            networkEntityAddReducer(NetworkActionPrefix.ADD_INTEGRATION_PIPEDRIVE_SETTINGS_PREFIX, null, (state, action) => action.integrationPipedriveSettings),
                            networkEntityEditReducer(NetworkActionPrefix.EDIT_INTEGRATION_PIPEDRIVE_SETTINGS_PREFIX, null, (state, action) => action.integrationPipedriveSettings),
                            networkEntityDeleteReducer(NetworkActionPrefix.DELETE_INTEGRATION_PIPEDRIVE_SETTINGS_PREFIX),
                            combineReducers({
                                Pipelines: pipeReducers(
                                    combineReducers({
                                        Data: combineReducers({
                                            '@integrationPipedriveSettingsPipelineIndex': pipeReducers(
                                                networkEntityEditReducer(NetworkActionPrefix.EDIT_INTEGRATION_PIPEDRIVE_SETTINGS_PIPELINE_PREFIX, null, (state, action) => action.integrationPipedriveSettingsPipeline),
                                                combineReducers({
                                                    PipelineStages: pipeReducers(
                                                        combineReducers({
                                                            Data: combineReducers({
                                                                '@integrationPipedriveSettingsPipelineStageIndex': pipeReducers(
                                                                    networkEntityEditReducer(NetworkActionPrefix.EDIT_INTEGRATION_PIPEDRIVE_SETTINGS_PIPELINE_STAGE_PREFIX, null, (state, action) => action.integrationPipedriveSettingsPipelineStage)
                                                                )
                                                            }, keyVariables)
                                                        }, keyVariables)
                                                    )
                                                })
                                            )
                                        }, keyVariables)
                                    })
                                )
                            })
                        )
                    }, keyVariables)
                }),
                (state, action) => {
                    let pipedriveIndex = -1,
                        pipedrive = null,

                        pipelineIndex = -1,
                        pipeline = null;

                    switch (action.type) {
                        case ActionType.SYNC_PIPEDRIVE_PIPELINES_PENDING:
                            pipedriveIndex = state.Data.getIndexByID(action.integrationPipedriveSettingsID);
                            pipedrive = state.Data[pipedriveIndex];

                            if (!pipedrive) {
                                return state;
                            }

                            return deepAssign(state, {
                                Data: {
                                    [pipedriveIndex]: { Custom: { status: RequestStatus.PENDING } }
                                }
                            });

                        case ActionType.SYNC_PIPEDRIVE_PIPELINES_SUCCESS:
                            pipedriveIndex = state.Data.getIndexByID(action.integrationPipedriveSettingsID);
                            pipedrive = state.Data[pipedriveIndex];

                            if (!pipedrive) {
                                return state;
                            }

                            return deepAssign(state, {
                                Data: {
                                    [pipedriveIndex]: action.response
                                }
                            });

                        case ActionType.SYNC_PIPEDRIVE_PIPELINES_FAIL:
                            pipedriveIndex = state.Data.getIndexByID(action.integrationPipedriveSettingsID);
                            pipedrive = state.Data[pipedriveIndex];

                            if (!pipedrive) {
                                return state;
                            }

                            return deepAssign(state, {
                                Data: {
                                    [pipedriveIndex]: { Custom: { status: RequestStatus.FAILED } }
                                }
                            });

                        case ActionType.ADD_INTEGRATION_PIPEDRIVE_SETTINGS_SUCCESS:
                            const data = state.Data.slice();
                            data.push({ ...action.integrationPipedriveSettings, ID: action.response });
                            return deepAssign(state, { Data: data });

                        case ActionType.EDIT_INTEGRATION_PIPEDRIVE_SETTINGS_SUCCESS:
                            return deepAssign(state, {
                                Data: state.Data.map(x => x.ID === action.integrationPipedriveSettings.ID ? { ...action.integrationPipedriveSettings } : x)
                            });

                        case ActionType.DELETE_INTEGRATION_PIPEDRIVE_SETTINGS_SUCCESS:
                            return deepAssign(state, {
                                Data: state.Data.filter(x => x.ID !== action.integrationPipedriveSettingsID)
                            });

                        case ActionType.EDIT_INTEGRATION_PIPEDRIVE_SETTINGS_PIPELINE_SUCCESS:
                            pipedriveIndex = state.Data.getIndexByID(action.integrationPipedriveSettingsID);
                            pipedrive = state.Data[pipedriveIndex];

                            if (!pipedrive) {
                                return state;
                            }

                            pipelineIndex = pipedrive.Pipelines.Data.getIndexByID(action.integrationPipedriveSettingsPipelineID);
                            pipeline = pipedrive.Pipelines.Data[pipelineIndex];

                            if (!pipeline) {
                                return state;
                            }

                            return deepAssign(state, {
                                Data: {
                                    [pipedriveIndex]: {
                                        Pipelines: {
                                            Data: {
                                                [pipelineIndex]: deepAssign(pipeline, action.integrationPipedriveSettingsPipeline)
                                            }
                                        }
                                    }
                                }
                            });

                        case ActionType.EDIT_INTEGRATION_PIPEDRIVE_SETTINGS_PIPELINE_STAGE_SUCCESS:
                            pipedriveIndex = state.Data.getIndexByID(action.integrationPipedriveSettingsID);
                            pipedrive = state.Data[pipedriveIndex];

                            if (!pipedrive) {
                                return state;
                            }

                            pipelineIndex = pipedrive.Pipelines.Data.getIndexByID(action.integrationPipedriveSettingsPipelineID);
                            pipeline = pipedrive.Pipelines.Data[pipelineIndex];

                            if (!pipeline) {
                                return state;
                            }

                            const stageIndex = pipeline.PipelineStages.Data.getIndexByID(action.integrationPipedriveSettingsPipelineStageID);
                            const stage = pipeline.PipelineStages.Data[stageIndex];

                            if (!stage) {
                                return state;
                            }

                            return deepAssign(state, {
                                Data: {
                                    [pipedriveIndex]: {
                                        Pipelines: {
                                            Data: {
                                                [pipelineIndex]: {
                                                    PipelineStages: {
                                                        Data: {
                                                            [stageIndex]: deepAssign(stage, action.integrationPipedriveSettingsPipelineStage)
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            });

                        default:
                            return state;
                    }
                }
            ),
            severaIntegrationSettings: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_SEVERA_INTEGRATION_SETTINGSES_PREFIX, defaults.NetworkArray),
                combineReducers({
                    Data: combineReducers({
                        '@severaIntegrationSettingsIndex': pipeReducers(
                            networkEntityAddReducer(NetworkActionPrefix.ADD_SEVERA_INTEGRATION_SETTINGS_PREFIX, null, (state, action) => action.severaIntegrationSettings),
                            networkEntityEditReducer(NetworkActionPrefix.EDIT_SEVERA_INTEGRATION_SETTINGS_PREFIX, null, (state, action) => action.severaIntegrationSettings),
                            networkEntityDeleteReducer(NetworkActionPrefix.DELETE_SEVERA_INTEGRATION_SETTINGS_PREFIX)
                        )
                    }, keyVariables)
                })
            ),
            accountingDataDimensionPreview: pipeReducers(
                (state, action) => {
                    state = state || defaults.AccountingDataDimensionPreview;
                    const dimension = `dimension${action.dimensionNumber}`;

                    switch (action.type) {
                        case ActionType.LOAD_ACCOUNTING_DATA_DIMENSION_PREVIEW_PENDING:
                            return deepAssign(state, {
                                [dimension]: { Custom: { status: RequestStatus.PENDING } }
                            });

                        case ActionType.LOAD_ACCOUNTING_DATA_DIMENSION_PREVIEW_SUCCESS:
                            return deepAssign(state, {
                                [dimension]: {
                                    Data: action.response,
                                    Custom: { status: RequestStatus.SUCCEEDED }
                                }
                            });

                        case ActionType.LOAD_ACCOUNTING_DATA_DIMENSION_PREVIEW_FAIL:
                            return deepAssign(state, {
                                [dimension]: {
                                    Custom: { status: RequestStatus.FAILED }
                                }
                            });

                        default:
                            return state;
                    }
                }
            ),
            accountingDataIntegrationStatus: networkObjectLoadReducer(NetworkActionPrefix.LOAD_ACCOUNTING_DATA_INTEGRATION_STATUS_PREFIX, defaults.NetworkObject),
            salesDataPreview: pipeReducers(
                (state, action) => {
                    state = state || defaults.SalesDataPreview;

                    switch (action.type) {
                        case ActionType.LOAD_ERP_INTEGRATION_PRODUCTS_PREVIEW_PREVIEW_PENDING:
                            return deepAssign(state, {
                                products: { Custom: { status: RequestStatus.PENDING } }
                            });

                        case ActionType.LOAD_ERP_INTEGRATION_CUSTOMERS_PREVIEW_PREVIEW_PENDING:
                            return deepAssign(state, {
                                customers: { Custom: { status: RequestStatus.PENDING } }
                            });

                        case ActionType.LOAD_ERP_INTEGRATION_PRODUCTS_PREVIEW_PREVIEW_SUCCESS:
                            return deepAssign(state, {
                                products: {
                                    Data: action.response,
                                    Custom: { status: RequestStatus.SUCCEEDED }
                                }
                            });

                        case ActionType.LOAD_ERP_INTEGRATION_CUSTOMERS_PREVIEW_PREVIEW_SUCCESS:
                            return deepAssign(state, {
                                customers: {
                                    Data: action.response,
                                    Custom: { status: RequestStatus.SUCCEEDED }
                                }
                            });

                        case ActionType.LOAD_ERP_INTEGRATION_PRODUCTS_PREVIEW_PREVIEW_FAIL:
                            return deepAssign(state, {
                                products: {
                                    Custom: { status: RequestStatus.FAILED }
                                }
                            });

                        case ActionType.LOAD_ERP_INTEGRATION_CUSTOMERS_PREVIEW_PREVIEW_FAIL:
                            return deepAssign(state, {
                                customers: {
                                    Custom: { status: RequestStatus.FAILED }
                                }
                            });

                        default:
                            return state;
                    }
                }
            ),
            lemonsoftIntegrationSettings: pipeReducers(
                networkActionReducer(NetworkActionPrefix.SEARCH_LEMONSOFT_INTEGRATION_SETTINGS_FOR_COMPANY_PREFIX, defaults.LemonsoftIntegrationSettings),
                networkEntityAddReducer(NetworkActionPrefix.ADD_LEMONSOFT_INTEGRATION_SETTINGS_PREFIX, null, (state, action) => action.lemonsoftIntegrationSettings),
                networkEntityEditReducer(NetworkActionPrefix.EDIT_LEMONSOFT_INTEGRATION_SETTINGS_PREFIX, defaults.LemonsoftIntegrationSettings, (state, action) => action.lemonsoftIntegrationSettings),
                (state, action) => {
                    switch (action.type) {
                        case ActionType.SEARCH_LEMONSOFT_INTEGRATION_SETTINGS_FOR_COMPANY_SUCCESS:
                            if (action.response) {
                                return deepAssign(state, action.response);
                            }
                            return state;
                        default:
                            return state;
                    }
                }
            ),
            integrationFinancialFileUploadResult: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.IMPORT_AND_PROCESS_INTEGRATION_FINANCIAL_FILES_PREFIX, defaults.IntegrationFinancialUploadBatch),
                (state, action) => {
                    switch (action.type) {
                        case ActionType.DROP_INTEGRATION_FINANCIAL_FILES_RESULT:
                            return deepAssign(state, defaults.IntegrationFinancialUploadBatch);

                        default:
                            return state;
                    }
                }
            ),
            microsoftTeamsBotLinkedConversations: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_MICROSOFT_TEAMS_BOT_LINKED_CONVERSATIONS_PREFIX, defaults.NetworkArray),
                networkActionReducer(NetworkActionPrefix.LINK_PENDING_TENANT_FOR_MICROSOFT_TEAMS_BOT_LINKED_CONVERSATIONS_PREFIX),
                networkActionReducer(NetworkActionPrefix.UNLINK_AND_PEND_TENANT_FOR_MICROSOFT_TEAMS_BOT_LINKED_CONVERSATIONS_PREFIX),
                (state, action) =>
                    action.type === ActionType.LINK_PENDING_TENANT_FOR_MICROSOFT_TEAMS_BOT_LINKED_CONVERSATIONS_SUCCESS ||
                    action.type === ActionType.UNLINK_AND_PEND_TENANT_FOR_MICROSOFT_TEAMS_BOT_LINKED_CONVERSATIONS_SUCCESS ?
                        defaults.NetworkArray :
                        state,
                networkObjectVoidReducer(NetworkActionPrefix.LOAD_ALL_MICROSOFT_TEAMS_BOT_LINKED_CONVERSATIONS_PREFIX)
            ),
            rawDataMappingColumnDataTypes: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_RAW_DATA_MAPPING_COLUMN_DATA_TYPES_PREFIX, defaults.NetworkArray, RawDataMappingColumnDataType, 'RawDataMappingColumnDataType'),
            rawDataSources: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_RAW_DATA_SOURCES_PREFIX, defaults.NetworkArray),
                combineReducers({
                    Data: combineReducers({
                        '@rawDataSourceIndex': pipeReducers(
                            networkEntityEditReducer(NetworkActionPrefix.EDIT_RAW_DATA_SOURCE_PREFIX, null, (state, action) => action.rawDataSource),
                            combineReducers({
                                Mappings: combineReducers({
                                    '@rawDataMappingIndex': pipeReducers(
                                        networkEntityAddReducer(NetworkActionPrefix.ADD_RAW_DATA_MAPPING_PREFIX, null, (state, action) => action.rawDataMapping),
                                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_RAW_DATA_MAPPING_PREFIX, null),
                                        networkEntityEditReducer(NetworkActionPrefix.EDIT_RAW_DATA_MAPPING_PREFIX, null, (state, action) => action.rawDataMapping),
                                        combineReducers({
                                            Columns: combineReducers({
                                                '@rawDataMappingColumnIndex': pipeReducers(
                                                    networkEntityAddReducer(NetworkActionPrefix.ADD_RAW_DATA_MAPPING_COLUMN_PREFIX, null, (state, action) => action.rawDataMappingColumn),
                                                    networkEntityDeleteReducer(NetworkActionPrefix.DELETE_RAW_DATA_MAPPING_COLUMN_PREFIX),
                                                    networkEntityEditReducer(NetworkActionPrefix.EDIT_RAW_DATA_MAPPING_COLUMN_PREFIX, null, (state, action) => action.rawDataMappingColumn)
                                                )
                                            }, keyVariables),
                                            Rules: pipeReducers(
                                                networkEntityAddAllReducer(NetworkActionPrefix.ADD_ALL_RAW_DATA_MAPPING_RULES_PREFIX, null, (state, action) => action.rawDataMappingRules),
                                                networkEntityDeleteAllReducer(NetworkActionPrefix.DELETE_ALL_RAW_DATA_MAPPING_RULES_PREFIX, null, (state, action) => action.rawDataMappingRuleIDs),
                                                networkEntityEditAllReducer(NetworkActionPrefix.EDIT_ALL_RAW_DATA_MAPPING_RULES_PREFIX, null, (state, action) => action.rawDataMappingRules)
                                            )
                                        })
                                    )
                                }, keyVariables),
                                Rows: pipeReducers(
                                    networkPaginationLoadReducer(NetworkActionPrefix.LOAD_RAW_DATA_ROW_SLICE_PREFIX, null),
                                    networkActionReducer(NetworkActionPrefix.LOAD_ERRONEOUS_RAW_DATA_ROW_SLICE_PREFIX)
                                )
                            }),
                            (state, action) => {
                                if (action.type === ActionType.LOAD_ERRONEOUS_RAW_DATA_ROW_SLICE_SUCCESS) {
                                    const { response } = action,
                                        rows = state.Rows.Data
                                            .filter(({ ID }) => !response.Data.getByID(ID))
                                            .concat(response.Data);

                                    return deepAssign(state, {
                                        ErroneousRows: response.TotalCount,
                                        Rows: {
                                            Count: rows.length,
                                            Custom: {
                                                erroneousSlice: true
                                            },
                                            Data: rows,
                                            NewCount: response.NewCount,
                                            NextID: response.NextID,
                                            Order: response.Order
                                        }
                                    });
                                }

                                return state;
                            })
                    }, keyVariables)
                }),
                networkObjectVoidReducer(ActionType.VOID_ALL_RAW_DATA_SOURCES)
            ),
            rawDataSourceStatuses: synchronizableEnumReducer(NetworkActionPrefix.LOAD_ALL_RAW_DATA_SOURCE_STATUSES_PREFIX, defaults.NetworkArray, RawDataSourceStatus, 'RawDataSourceStatus'),
            excelBatchPreview: pipeReducers(
                networkEntityLoadReducer(NetworkActionPrefix.PREVIEW_INTEGRATION_FINANCIAL_UPLOAD_EXCEL_BATCH_PREFIX, defaults.FinancialBatchPreviewReport),
                (state, action) => {
                    switch (action.type) {
                        case ActionType.CREATE_INTEGRATION_FINANCIAL_UPLOAD_BATCH_FROM_EXCEL_SUCCESS:
                            return deepAssign(state, {
                                Custom: {
                                    batchID: action.response
                                }
                            });

                        case ActionType.CREATE_INTEGRATION_FINANCIAL_UPLOAD_BATCH_FROM_EXCEL_PENDING:
                        case ActionType.IMPORT_INTEGRATION_FINANCIAL_UPLOAD_EXCEL_BATCH_SUCCESS:
                            return deepAssign(defaults.FinancialBatchPreviewReport, {
                                Custom: {
                                    batchID: null
                                }
                            });

                        case ActionType.PREVIEW_INTEGRATION_FINANCIAL_UPLOAD_EXCEL_BATCH_SUCCESS:
                            return deepAssign(state, {
                                Custom: {
                                    batchID: action.batchID
                                }
                            });

                        default:
                            return state || deepAssign(defaults.FinancialBatchPreviewReport, {
                                Custom: {
                                    batchID: null
                                }
                            });

                    }
                }
            ),
            excelBatchStatus: pipeReducers(
                (state, action) => {
                    switch (action.type) {
                        case ActionType.CREATE_INTEGRATION_FINANCIAL_UPLOAD_BATCH_FROM_EXCEL_PENDING:
                            return deepAssign(state, {
                                Custom: {
                                    batchID: null,
                                    status: RequestStatus.UNSYNCED
                                }
                            });

                        case ActionType.IMPORT_INTEGRATION_FINANCIAL_UPLOAD_EXCEL_BATCH_SUCCESS:
                            return deepAssign(state, {
                                Custom: {
                                    batchID: action.batchID
                                }
                            });

                        default:
                            return state || deepAssign(defaults.NetworkObject, {
                                Custom: {
                                    batchID: null
                                }
                            });
                    }
                },
                networkObjectLoadReducer(NetworkActionPrefix.CHECK_INTEGRATION_FINANCIAL_UPLOAD_EXCEL_BATCH_STATUS_PREFIX)
            ),
            financialSystemUploadBatches: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_LATEST_FINANCIAL_SYSTEM_UPLOAD_BATCHES_PREFIX, defaults.NetworkArray),
                (state, action) => {
                    if (action.type === ActionType.UNLINK_FINANCIAL_SYSTEM_BATCHES_FROM_LEGAL_ENTITY_SUCCESS) {
                        return deepAssign(state, {
                            Data: state.Data.filter(({ CompanyLegalEntityID }) => CompanyLegalEntityID !== action.companyLegalEntityID)
                        });
                    }

                    if ((action.type === ActionType.CREATE_INTEGRATION_FINANCIAL_UPLOAD_BATCH_FROM_EXCEL_SUCCESS || action.type === ActionType.IMPORT_AND_PROCESS_INTEGRATION_FINANCIAL_FILES_SUCCESS) &&
                    (action.batchLegalEntityID && !state.Data.some(({ CompanyLegalEntityID }) => CompanyLegalEntityID === action.batchLegalEntityID))) {
                        return defaults.NetworkArray;
                    }

                    return state;
                },
                networkObjectVoidReducer(ActionType.VOID_ALL_INTEGRATION_SOURCE_COMPANY_STATUSES),
                networkObjectVoidReducer(ActionType.IMPORT_INTEGRATION_FINANCIAL_UPLOAD_EXCEL_BATCH_SUCCESS)
            ),
            erpAccountLists: pipeReducers(
                networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_ERP_ACCOUNT_LISTS_PREFIX, defaults.NetworkArray),
                networkObjectLoadReducer(NetworkActionPrefix.IMPORT_ERP_ACCOUNT_LISTS_PREFIX, defaults.NetworkArray)
            )
        }),
        (state, action) => {
            switch (action.type) {
                case ActionType.DELETE_PERFORMANCE_INDICATOR_SUCCESS:
                    return integrations(undefined, { type: '@@redux/INIT' });

                case ActionType.IMPORT_AND_PROCESS_INTEGRATION_FINANCIAL_FILES_SUCCESS:
                    return deepAssign(state, {
                        integrationSourceCompanyStatuses: {
                            Data: state.integrationSourceCompanyStatuses.Data.map(model => model.SourceID === action.integrationSourceID ?
                                { ...model, SourceStatusID: IntegrationSourceStatus.IN_PROGRESS } : model)
                        }

                    });

                default:
                    return state;
            }
        }
    );

export default integrations;
